import React from 'react'
import { Button, Col, Grid, Icon, Row, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/FileUploader/file-uploader.module.scss'
import StatusIcon from 'components/FileUploader/subcomponents/StatusIcon'
import clsx from 'clsx'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'

const AttachmentRow = ({ name, url, created_at, className }) => {
  return (
    <Row className={clsx(styles['row'], className)} key={'file-row-' + name} flexWrap={'nowrap'}>
      <Grid gap={16} wrap={false}>
        <Col className={styles['col']}>
          <StatusIcon status={'loaded'} />
        </Col>

        <Col className={clsx(styles['col'], styles['col-2'])}>
          <Grid direction={'column'} gap={4}>
            <Typography variant={'Body-15'} noMargin className={styles['row__file-name']}>
              {name}
            </Typography>
            <Typography variant={'Body-10'} color={'Label-Secondary'} noMargin>
              {created_at &&
                format(parse(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()), 'd MMMM yyyy')}
            </Typography>
          </Grid>
        </Col>
        <Col className={clsx(styles['col'], styles['col-3'])}>
          <Button
            color={'Interface-Seventh'}
            component={'a'}
            target={'_blank'}
            href={url}
            rel="noreferrer"
            noLabel
            startIcon={<Icon name={'download'} />}
            size={'s'}
          />
        </Col>
      </Grid>
    </Row>
  )

  // return (
  //   <Row className={clsx(styles['row'], className)}>
  //     <Grid s={'10'} className={clsx(styles['col'], styles['col-2'])}>
  //       <StatusIcon status={'loaded'} />
  //       <Grid>
  //         <Typography variant={'Body-15'} noMargin>
  //           {name}
  //         </Typography>
  //         <Typography
  //           variant={'p10'}
  //           color={'Label-Secondary'}
  //           noMargin
  //           className={styles['row__file-name']}
  //         >
  //           {created_at &&
  //             format(
  //               parse(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()),
  //               'd MMMM yyyy',
  //             )}
  //         </Typography>
  //       </Grid>
  //     </Grid>
  //     <Col s={'1'} className={clsx(styles['col'], styles['col-3'])}>
  //       <a href={url} target={'_blank'} rel="noreferrer">
  //         <Button
  //           noLabel
  //           startIcon={<Icon name={'download'} />}
  //           color={'Label-Secondary'}
  //           size={'m'}
  //           onClick={remove}
  //         />
  //       </a>
  //     </Col>
  //   </Row>
  // )
}

AttachmentRow.propTypes = {
  url: PropTypes.string,
  created_at: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  total: PropTypes.number,
  remove: PropTypes.func,
}

export default AttachmentRow
